import "./Fillbutton.css";

const Fillbutton = ({
  text = "",
  className = "",
  style = "",
  onClick,
  type = "button",
}) => {
  return (
    <button
      type={type}
      className={`common_fill_btn ${className}`}
      style={style ? style : {}}
      onClick={onClick}
    >
      {text}
    </button>
  );
};

export default Fillbutton;
